import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import './styles/global.css';
import { AuthProvider } from './app/providers/AuthProvider';
import App from './App';
import { ConfigProvider } from 'antd';
import { antdTheme } from './theme';
import ThemeProvider from './theme/ThemeProvider';
import esES from 'antd/es/locale/es_ES';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ConfigProvider locale={esES} theme={antdTheme}>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
